import qs from 'qs';
import { ParsedUrlQuery } from 'querystring';

export const Routes = {
  home: () => '/',
  authenticated: (route?: string) => `/authenticated${route ? `?route=${route}` : ''}`,
  onboarding: (route?: string) => `/onboarding${route ? `?route=${route}` : ''}`,
  registerCommunity: (route?: string) => `/register-community${route ? `?route=${route}` : ''}`,

  landingPage: (companySlug?: string) => (companySlug ? `/${companySlug}` : '/'),

  validationLandingPage: (companySlug: string, regionId: string, pageType: 'hired-in-plant' | 'business') =>
    `/landing/${companySlug}/${regionId}/${pageType}`,

  community: () => '/community',

  guides: (companySlug?: string) => `${companySlug ? `/${companySlug}` : ''}/guides`,
  guideBook: (guideBookSlug: string, companySlug?: string) => `${companySlug ? `/${companySlug}` : ''}/guides/${guideBookSlug}`,

  blog: (companySlug?: string) => `${companySlug ? `/${companySlug}` : ''}/blog`,
  blogPost: (blogPostSlug: string, companySlug?: string) => `${companySlug ? `/${companySlug}` : ''}/blog/posts/${blogPostSlug}`,

  jobs: (companySlug?: string) => `/jobs`,

  contactUs: () => `/contact-us`,

  ir35: (companySlug?: string) => `${companySlug ? `/${companySlug}` : ''}/ir35`,

  switchToJoveHome: () => {
    return '/switch-with-jove';
  },
  switchToJoveSubmitQuoteSuccess: () => '/switch-with-jove/upload-policy-schedule-success',
  uploadFileExtractAndSubmitQuote: () => '/switch-with-jove/extract-document-info',
  recruitmentHomeLandingPage: () => '/personal/recruitment',
  recruitmentAgency: () => '/recruitmentagency',
  brokerOnboardingSubmit: () => '/brokers/activation',
  brokerLandingPage: () => '/brokers/landing',
  editBrokerLegalEntity: (brokerId: string, params?: { autoEdit?: 'true' | 'false'; showTabs?: boolean }) =>
    `/brokers/activation/${brokerId}/legal-entity?${qs.stringify(params)}`,
  brokerEntitySign: (brokerId: string, params?: { showTabs?: boolean }) => `/brokers/activation/${brokerId}/signature?${qs.stringify(params)}`,
  switchToJoveUploadPolicyDocuments: () => '/switch-with-jove/upload-policy-documents',
};

export const routeHasCompanySlug = (query: ParsedUrlQuery): boolean => !!query['company-slug'];

export const goToWebsiteHomePage = (router) => {
  router?.replace('/personal/commercial-combined-business');
};
